import { makeRange, RangeInputError, type DateRange } from '@chagok/domain';

export type PeriodMode = 'months' | 'year' | 'days';
export interface Period extends DateRange {
  mode: PeriodMode;
  startInput: string;
  endInput: string;
}

export function periodFrom(mode: PeriodMode, startInput: string, endInput: string): Period {
  return { mode, startInput, endInput, ...makeRange(mode, startInput, endInput) };
}

export const thisMonth = (today: string) => periodFrom('months', today.slice(0, 7), today.slice(0, 7));
export const thisYear = (today: string) => periodFrom('year', today.slice(0, 4), today.slice(0, 4));

export function tryPeriod(mode: PeriodMode, startInput: string, endInput: string): Period | string {
  try {
    return periodFrom(mode, startInput, endInput);
  } catch (error) {
    if (error instanceof RangeInputError || error instanceof RangeError) return error.message;
    throw error;
  }
}
